import { render } from "./OrderCoverPrint.vue?vue&type=template&id=727b1cd9&scoped=true&ts=true"
import script from "./OrderCoverPrint.vue?vue&type=script&lang=ts"
export * from "./OrderCoverPrint.vue?vue&type=script&lang=ts"

import "./OrderCoverPrint.vue?vue&type=style&index=0&id=727b1cd9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727b1cd9"]])

export default __exports__